import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import TextBox from "devextreme-react/text-box";
import { useNavigate } from "react-router-dom";
import useFetch from "../../Hooks/useFetch";
import { isMobile } from "../../Utils/media-query";
import handlePostProvideActionPO from "../../Utils/handlePOST/handlePostProvideActionPO";

export default function ActionProvidedPurchaseOrders({
  orderId,
  setNotifications,
  onClose,
  mutate,
}) {
  const navigate = useNavigate();
  const fetch = useFetch(navigate);

  // store deny reason
  const submitActionReason = useRef("");

  const onValueChanged = (e) => {
    submitActionReason.current = e.value;
  };

  // ---------- SUBMIT DENY ----------
  const submitActionProvided = useCallback(async () => {
    if (
      !submitActionReason.current ||
      submitActionReason.current.trim().length === 0
    ) {
      setNotifications?.({
        success: false,
        message: "Enter a reason is required to send for review.",
      });
      return;
    }

    const { response, isDataGood } = await handlePostProvideActionPO(
      submitActionReason.current,
      orderId,
      fetch,
    );

    setNotifications?.(response);

    if (isDataGood) {
      mutate?.();
      onClose();
    }
  }, [orderId, fetch, setNotifications, onClose, mutate]);
  // ---------- BUTTON OPTIONS ----------
  const submitOptions = useMemo(
    () => ({
      stylingMode: "contained",
      type: "default",
      text: "Submit for review",
      onClick: submitActionProvided,
    }),
    [submitActionProvided],
  );

  const cancelOptions = useMemo(
    () => ({
      stylingMode: "outlined",
      text: "Cancel",
      onClick: onClose,
    }),
    [onClose],
  );

  return (
    <Popup
      visible={true}
      onHiding={onClose}
      hideOnOutsideClick={true}
      title={`Submit PO Request ${orderId} for Review`}
      width={isMobile ? "100%" : 500}
      height="auto"
      resizeEnabled={true}
    >
      <div style={{ padding: "12px" }}>
        <div style={{ marginBottom: "8px", fontWeight: 500, color: "white" }}>
          Please enter a reason before submitting for review.
        </div>
      </div>
      <TextBox
        spellcheck={true}
        placeholder="Type comment..."
        onValueChanged={onValueChanged}
        valueChangeEvent="input"
        height={50}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={cancelOptions}
      />

      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={submitOptions}
      />
    </Popup>
  );
}
